import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import React from "react";
import TabNavigation from "../tabNavigation";
import TabNavigationContent from "../tabNavigationContent";
export default function TabNavigationSwitcher(props) {
    return props.documentType === DOCUMENT_TYPE.CONTENT ? (React.createElement(TabNavigationContent, { ...props })) : (React.createElement(TabNavigation, { ...props }));
}
